import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ShipmentsService } from 'src/app/core/services/basicServices/shipments.service';
import { AddEditRatesComponent } from './add-edit-rates/add-edit-rates.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-rate-setup',
  templateUrl: './rate-setup.component.html',
  styleUrls: ['./rate-setup.component.scss']
})
export class RateSetupComponent implements AfterViewInit {

  displayedColumns: string[] = ['serialId', 'rateType', 'ratePercentage','rateValue','status','actions'];
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator,{static:false}) paginator: MatPaginator;
 
  tableModel = {search:'', startDate:null,endDate:null,page:1,size:10 };

  constructor(public Alerts: MatSnackBar,private shipmentService:ShipmentsService,
    public router: Router,
    public dialog: MatDialog,
  ) { 
    this.dataSource.paginator = this.paginator; }

    ngAfterViewInit() {
      this.dataTableConfig();
    }
  
    dataTableConfig() {
      this.getList();
      this.dataSource.paginator = this.paginator;
    }

    getList(){
      this.shipmentService.getAllRateSetup().subscribe(res=>{
        if(res.length>0){
          this.dataSource.data=res;
        }
        else{
          this.dataSource.data=[];
        }
      })
    }
    
  onPaginate(pageEvent: PageEvent) {
    // debugger
    this.tableModel.size = pageEvent.pageSize;
    this.tableModel.page = pageEvent.pageIndex + 1;
    this.getList();
    // console.log(this.dataSource.sort)
  }

  onToggle(event,id){
    let status = event.checked ? 1 : 0;
    this.shipmentService.activeInacticeRateStatus(id,status).subscribe(res=>{
      if(res){
        this.Alerts.open(res.message,'OK');
      this.getList()

      }
    })
  }

  view(id){
    if (id) {
      this.router.navigate(["main/viewShipment/"], { queryParams: { id: id } });
    } 
  }
  openModal(id?: number) {
    const dialogRef = this.dialog.open(AddEditRatesComponent, {
      width: "450px",
      data: { id: id },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {

        this.dataTableConfig();
      }
    });
  }

  reset(){
    this.tableModel.search='';
    this.tableModel.startDate=null;
    this.tableModel.endDate=null;
    this.getList();
  }
}
